var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{key:_vm.$store.getters['resource/currentResource'].key,staticClass:"white-container"},[_c('trigger-view',{on:{"save":_vm.saveEvent}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }